import { render } from "./PieComponent.vue?vue&type=template&id=ecebddda&scoped=true"
import script from "./PieComponent.vue?vue&type=script&lang=js"
export * from "./PieComponent.vue?vue&type=script&lang=js"

import "./PieComponent.vue?vue&type=style&index=0&id=ecebddda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecebddda"]])

export default __exports__